import Modal from 'react-bootstrap/Modal'
import styles from './style.module.css'

const CustomModal = ({ isChange = false, className = '', ...props }) => {
    return (
        <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size={props?.size || 'xl'}
            fullscreen={props?.fullscreen}
            {...props}
        >
            <Modal.Header  closeButton>
                <h1>{props?.text}</h1>
            </Modal.Header>
            <Modal.Body className={ `  ${ isChange ? styles.modal_body_withOutScroll : styles.modal_body_height}`}>
                {props?.children}
            </Modal.Body>
           
        </Modal>
    )
}

export default CustomModal

// isChange ? styles[className] : styles.modal_fixed_body
